import styled, { css } from "styled-components";

export const RadioInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 1rem;
  min-height: 1rem;
  margin: 0 0.75rem 0 0;

  outline: none;
  cursor: pointer;
  appearance: none;
  border-radius: 100%;
  border: 0.125rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.checkoutPrimaryColor};

  position: relative;

  &:focus {
    box-shadow: 0 0 0.25rem ${(props) => `${props.theme?.colors?.textColor}a0`};
  }

  &::before {
    position: absolute;

    content: "";
    min-width: 0.6rem;
    min-height: 0.6rem;

    opacity: 0;
    border-radius: 100%;
    background: ${(props) =>
      props.theme?.checkoutStepsOffers?.checkoutPrimaryColor};

    transition: all ease-in-out 25ms;
  }

  &:checked::before {
    opacity: 1;
  }
`;

export const Label = styled.label`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  cursor: pointer;
  color: ${({ theme }) => theme.colors?.textColor};

  @media (max-width: 360px) {
    font-size: 0.875rem;
    line-height: 1rem;
  }

  @media (max-width: 320px) {
    font-size: 0.75rem;
  }
`;

export const DisabledText = styled.span`
  font-family: Inter;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  text-align: end;

  margin: 0 0 0 auto;
  padding: 0 0 0 0.75rem;

  @media (max-width: 330px) {
    font-size: 0.625rem;
    line-height: 0.825rem;
  }
`;

interface IInputContainerProps {
  disabled: boolean;
  checked: boolean;
  mobile?: boolean;
}

export const InputContainer = styled.div<IInputContainerProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;
  padding: 1rem 1.5rem;

  border-radius: 0.5rem;
  opacity: ${(props) => (props.disabled ? "0.4" : "1")};
  border: 0.094rem solid
    ${({ theme }) => theme.checkoutOnePage?.inputBorderColor};
  background: ${({ theme }) => theme.checkoutOnePage?.inputBackground};

  position: relative;

  &:hover {
    border: 0.094rem solid
      ${(props) =>
        `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a0`};
  }

  &:focus {
    border: 0.094rem solid
      ${(props) =>
        `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a0`};
  }

  &:active {
    border: 0.094rem solid
      ${(props) =>
        `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a8`};
  }

  .installments {
    margin: 1rem 0 0;
  }

  ${(props) =>
    props.checked &&
    css`
      border: 0.125rem solid
        ${(props) =>
          `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a8`};
    `}

  ${(props) =>
    props.mobile
      ? css`
          justify-content: center;
          padding: 0.625rem 0.5rem;

          ${RadioInput} {
            width: 0;
            height: 0;
            min-width: 0;
            min-height: 0;

            margin: 0;
            border: none;

            position: absolute;

            &::before {
              display: none;
            }
          }
        `
      : css`
          @media (max-width: 360px) {
            padding: 0.75rem;
          }

          @media (max-width: 330px) {
            padding: 0.5rem;
          }
        `}
`;

export const InputContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  position: relative;
`;

export const WrapperInputs = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;

  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));

  width: 100%;
  margin: 0 0 1rem;

  &:last-child {
    margin: 0;
  }
`;
